module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular.bba5f7e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Regular.svg
// module id = 335
// module chunks = 3